import { useSelector } from 'react-redux';
import { RootState } from '../index';

export type UseRootState = () => RootState;

export const useRootState: UseRootState = () => useSelector<RootState, RootState>(state => state);
